import { idConditionDG } from '../../utils/idsHelper'

/**
 * Contagem canônica do Resumo DG — fonte ÚNICA para a tela e para o PDF.
 *
 * A classificação é por id de `domain_value`, nunca pelo texto do rótulo: os rótulos vêm do
 * servidor e um ajuste de texto lá reclassificaria as matrizes em silêncio.
 *
 * A decomposição espelha a das telas de manejo (`DG.jsx`, `DGRessinc.jsx`), que por sua vez usam
 * `statisticsToDG`: prenhes e vazias JÁ INCLUEM seus descartes, e "descartes" é uma anotação
 * transversal — não um terceiro balde. Assim o número do papel é o mesmo que o veterinário
 * acabou de ver na tela. `resumoDgCounts.test.js` trava esse acordo.
 */

export const DIAGNOSIS_TYPES = {
  PENDING: 'pending',
  PREGNANT: 'pregnant',
  EMPTY: 'empty',
  OTHER: 'other',
}

const TYPE_BY_CONDITION = {
  [idConditionDG.pregnant]: DIAGNOSIS_TYPES.PREGNANT,
  [idConditionDG.pregnantBull]: DIAGNOSIS_TYPES.PREGNANT,
  [idConditionDG.pregnantDiscard]: DIAGNOSIS_TYPES.PREGNANT,
  [idConditionDG.empty]: DIAGNOSIS_TYPES.EMPTY,
  [idConditionDG.emptyDiscard]: DIAGNOSIS_TYPES.EMPTY,
}

const DISCARD_CONDITIONS = [
  idConditionDG.pregnantDiscard,
  idConditionDG.emptyDiscard,
]

export const getDiagnosisType = (row) => {
  if (!row || !row.isSaved) return DIAGNOSIS_TYPES.PENDING
  return TYPE_BY_CONDITION[row.condicaoDG] || DIAGNOSIS_TYPES.OTHER
}

export const isDiscardRow = (row) =>
  Boolean(row && row.isSaved && DISCARD_CONDITIONS.includes(row.condicaoDG))

export const countResumoDg = (rows = []) => {
  const counts = rows.reduce(
    (acc, row) => {
      acc[getDiagnosisType(row)] += 1
      if (isDiscardRow(row)) {
        if (row.condicaoDG === idConditionDG.pregnantDiscard)
          acc.discardedPregnant += 1
        else acc.discardedEmpty += 1
      }
      return acc
    },
    {
      pending: 0,
      pregnant: 0,
      empty: 0,
      other: 0,
      discardedPregnant: 0,
      discardedEmpty: 0,
    },
  )

  const total = rows.length
  const saved = total - counts.pending

  return {
    ...counts,
    total,
    saved,
    discarded: counts.discardedPregnant + counts.discardedEmpty,
    pregnancyRate: total > 0 ? (counts.pregnant / total) * 100 : 0,
  }
}
